var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgAddImageIcon = function SvgAddImageIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20648 -1245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128-832Zm-6.222,8a1.712,1.712,0,0,1-1.256-.522,1.712,1.712,0,0,1-.522-1.256v-12.444a1.712,1.712,0,0,1,.522-1.255,1.712,1.712,0,0,1,1.256-.522h7.111v1.778h-7.111v12.444h12.444v-7.111H136v7.111a1.712,1.712,0,0,1-.522,1.256,1.712,1.712,0,0,1-1.256.522Zm.889-3.556h10.667L130-832l-2.667,3.555-2-2.667Zm9.778-7.111v-1.778h-1.778v-1.778h1.778V-840h1.778v1.778H136v1.778h-1.778v1.778Z",
    transform: "translate(-20766 2087)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(-20648 1245)",
    fill: "none"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddImageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_image_icon.5d19c3d9.svg";
export { ForwardRef as ReactComponent };